<template>
  <div class="od-container" id="landing">

    <ul class="cont_list" v-if="event !== null">
      <li>
        <template v-if="isMobile">
          <template v-for="i in 5">
            <img
              :key="`mobile-${i}`"
              v-if="event[`mobile${i}`] !== ''" v-lazy="`${publicPath}upload/event/${event[`mobile${i}`]}`" style="width: 100%" />
          </template>
        </template>
        <template v-else>
          <template v-for="i in 5">
            <img
              :key="`pc-${i}`"
              v-if="event[`pc${i}`] !== ''" v-lazy="`${publicPath}upload/event/${event[`pc${i}`]}`" style="width: 100%" />
          </template>
        </template>
      </li>
    </ul>

    <!-- formbox -->
    <div class="formbox" v-if="event !== null && event.useCounsel">
      <div class="inbox">
        <h3 class="h3">상담 신청하기</h3>
        <ul class="flist">
          <li class="required">
            <label for="customer-name" class="label">
              <span>이름</span>
              <em class="ml-3 text-danger" v-if="errors.has('customer-name')">필수 입력 항목입니다.</em>
            </label>
            <input type="text"
                   class="fr_input full" placeholder="-"
                   name="customer-name"
                   id="customer-name"
                   v-model="customerName"
                   ref="customer-name"
                   v-validate="'required'" />
          </li>
          <li class="required">
            <label for="customer-contact" class="label">
              <span>연락처</span>
              <em class="ml-3 text-danger" v-if="errors.has('customer-contact')">
                <template v-if="errors.firstRule('customer-contact') === 'required'">
                  필수 입력항목입니다.
                </template>
                <template v-else-if="errors.firstRule('customer-contact') === 'numeric'">
                  숫자만 입력하세요.
                </template>
                <template v-else-if="errors.firstRule('customer-contact') === 'mobile'">
                  잘못된 연락처입니다.
                </template>
              </em>
            </label>
            <input type="text"
                   class="fr_input full"
                   placeholder="-"
                   name="customer-contact"
                   id="customer-contact"
                   ref="customer-contact"
                   v-model="customerContact"
                   v-validate="'required|numeric|mobile'" maxlength="14" />
          </li>
        </ul>
        <div class="terms_agree">
          <input type="checkbox" name="agree-sms" id="agree-sms" v-model="agreeSms">
          <label for="agree-sms">SMS 수신 여부</label>
        </div>
        <div class="terms_agree">
          <input type="checkbox" name="agree-privacy" id="agree-privacy" v-model="agreePrivacy" v-validate="'required'">
          <label for="agree-privacy">개인정보취급방침동의</label>
          <a href="/privacy" class="btn_view" target="_blank">[자세히보기]</a>
          <em class="ml-3 text-danger" v-if="errors.has('agree-privacy')" style="font-size: 28px;display: block;">필수 동의 항목입니다.</em>
        </div>

        <div class="button_area">
          <input type="submit" value="신청하기" class="btn" @click="submit">
        </div>
      </div>
    </div>
    <!-- e : formbox -->
  </div>

</template>

<script>
export default {
  name: 'Landing',
  computed: {
    isMobile() {
      return window.innerWidth < 758;
    },
  },
  watch: {
    imgCount(v) {
      if (v === 0) {
        console.log('scrollTop');
        window.scrollTo(0, 0);
      }
    },
  },
  data() {
    return {
      imgCount: 0,
      event: null,
      customerName: '',
      customerContact: '',
      agreeSms: false,
      agreePrivacy: false,
    };
  },
  mounted() {
    this.init();
    if (this.$route.params && this.$route.params.path) {
      this.axios.get(`/api/event/${this.$route.params.path}`)
        .then(({ data }) => {
          this.event = data;

          this.imgCount = 0;

          if (!this.isMobile) {
            for (let i = 1; i <= 5; i += 1) {
              if (this.event[`pc${i}`] !== '') {
                this.imgCount += 1;
              }
            }
          } else {
            for (let i = 1; i <= 5; i += 1) {
              if (this.event[`mobile${i}`] !== '') {
                this.imgCount += 1;
              }
            }
          }

          if (this.imgCount > 0) {
            this.$Lazyload.$on('loaded', () => {
              console.log('loaded');
              this.imgCount -= 1;
            });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    } else {
      this.$router.push({ name: 'home' });
    }
  },
  methods: {
    init() {
      this.customerName = '';
      this.customerContact = '';
      this.agreeSms = false;
      this.agreePrivacy = false;

      this.errors.remove();
    },
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) {
        const firstField = Object.keys(this.errors.collect())[0];

        // this assumes you have a conviention of ref and field name here I just add the
        // Input suffix to the field name as you can see in the template.
        this.$refs[`${firstField}`].focus();
        this.$refs[`${firstField}`].scrollIntoView();
        return;
      }

      this.$axios.post('/api/counsel/apply', {
        name: this.customerName,
        contact: this.customerContact,
        agreeSms: this.agreeSms,
        darkseagreen: this.agreePrivacy,
        event: this.event.path,
      })
        .then(() => {
          // eslint-disable-next-line no-alert
          alert('상담 신청이 완료되었습니다.');
          window.scrollTo(0, 0);
          this.init();
        })
        .catch((e) => {
          console.log(e);
          // eslint-disable-next-line no-alert
          alert('상담 신청에 실패했습니다.\n잠시 후 다시 시도 부탁드립니다.');
        });
    },
  },
};
</script>

<style scoped>

</style>
